import Highcharts from 'highcharts'
import I18n from 'i18n'
import { SeriesPoint } from './ComplianceChartProps'
import { MetricData } from 'components/common/types/ResearchDashboardMetricsDTO'

export const buildChartOptions = (
  data: SeriesPoint[],
  color: string,
  currentWeekLabel?: string
): Highcharts.Options => ({
  chart: { type: 'column', height: 350, backgroundColor: '#F4F7FA' },
  title: { text: '' },
  xAxis: {
    type: 'category',
    title: { text: '' },
    labels: {
      align: 'center',
      style: {
        fontSize: '11px',
        color: '#000000'
      }
    }
  },
  yAxis: {
    title: { text: '' },
    min: 0,
    max: 100,
    stackLabels: {
      enabled: false
    },
    labels: {
      style: {
        color: '#000000'
      }
    }
  },
  series: [
    {
      name: I18n.t('components.dashboards.research_dashboard.charts.remaining'),
      type: 'column',
      data: data.map(p => ({
        name: p.x as string,
        y: 100 - p.y,
        color: currentWeekLabel !== undefined && String(p.x) === currentWeekLabel ? '#FFD0A0' : undefined
      })),
      color: '#858DAB',
      stack: 'compliance',
      showInLegend: false
    },
    {
      id: 'compliance',
      name: I18n.t('components.dashboards.research_dashboard.charts.compliance_label'),
      type: 'column',
      data: data.map(p => ({
        name: p.x as string,
        y: p.y,
        color: currentWeekLabel !== undefined && String(p.x) === currentWeekLabel ? '#FFA239' : undefined
      })),
      color: '#011258',
      stack: 'compliance'
    }
  ],
  tooltip: {
    shared: false,
    formatter: function (this: Highcharts.TooltipFormatterContextObject) {
      const point = this.point as Highcharts.Point | undefined
      const pointName = point?.name
      const baseX = this.x
      const label: string = pointName !== undefined ? String(pointName) : (baseX !== undefined ? String(baseX as unknown as string) : '')
      const complianceText: string = I18n.t('components.dashboards.research_dashboard.charts.compliance_label')

      let complianceValue: number
      if (this.series.options.id === 'compliance') {
        const pointY = point?.y
        complianceValue = typeof this.y === 'number' ? this.y : (typeof pointY === 'number' ? pointY : 0)
      } else {
        const remainingY = typeof this.y === 'number' ? this.y : (typeof point?.y === 'number' ? point.y : 0)
        complianceValue = 100 - remainingY
      }

      const colorStr: string = String(color)
      return `<b>${label}</b><br/><span style="color:${colorStr}">${complianceText}</span>: <b>${String(complianceValue)}%</b>`
    }
  },
  plotOptions: {
    column: {
      stacking: 'normal',
      animation: false,
      borderRadius: 0,
      pointPadding: 0.4,
      groupPadding: 0.2,
      pointWidth: 18
    },
    series: {
      states: {
        hover: {
          enabled: true
        },
        inactive: {
          opacity: 1
        }
      }
    }
  },
  legend: { enabled: false },
  credits: { enabled: false }
})

export const buildPoints = (metricData: MetricData): SeriesPoint[] => {
  if ((metricData?.history) == null) return []
  return metricData.history.map(item => ({ x: item.label, y: Math.round(item.percent) }))
}
